<svelte:head>
	
	<link 
				rel="stylesheet"
				href="https://unpkg.com/@picocss/pico@latest/css/pico.min.css"
	/>

</svelte:head>
<slot />